import { normalize as norm, schema } from 'normalizr';
import { Map, fromJS } from 'immutable';
import getDeadlineItems from './dedline';
import getSection from './section';
import {
  SALE,
  RENT,
  RENTDAILY,
  APARTMENTS,
  COMMERCIALS,
  LANDS,
  NOT_IMPORTANT,
  HAS_YES,
  HAS_NO,
  IS_YES,
  IS_NO,
  REALTY_TYPES
} from '../consts';

export function count (filter, field) {
  const value = filter.get(field);

  return value ? value.split(',').length : 0;
}

export function normalize (dictionaries) {
  const option = new schema.Entity('options', {}, { idAttribute: (value, parent) => parent.slug + '_' + value.id });
  const unit = new schema.Entity('units', {options: [option]}, { idAttribute: value => value.id });
  const dictionarySchema = [ unit ];

  return norm(dictionaries, dictionarySchema);
}

function getDealTypeItems (dealType, realtyType) {
  const sale = {type: 'option', label: 'Продажа', value: SALE};
  const rent = {type: 'option', label: 'Аренда', value: RENT};
  const rentDaily = {type: 'option', label: 'Посуточно', value: RENTDAILY};

  const map = {
    [SALE + APARTMENTS]: [sale, rent, rentDaily],
    [SALE + COMMERCIALS]: [sale, rent],
    [SALE + LANDS]: [sale, rent, rentDaily]
  };

  return map[dealType + realtyType] || [];
}

const dictionaryItemsCache = {};
const defaultOptions = {
  interval: {type: 'option', label: 'за все время', value: null},
  floorPosition: {type: 'option', value: null, label: 'Неважно'},
  leasePeriod: {type: 'option', value: null, label: 'Неважно'},
  gender: {type: 'option', value: null, label: 'Неважно'},
  personNumber: {type: 'option', value: null, label: 'Неважно'},
  dataSource: {type: 'option', value: null, label: 'Неважно'}
};

function getAuthorItems () {
  return [
    {type: 'option', label: 'все', value: null},
    {type: 'option', label: 'от частников', value: 'onlyOwners'},
    {type: 'option', label: 'от застройщиков', value: 'onlyFromBuilder'}
  ];
}

function getCornerItems () {
  return [
    {label: 'угловая', value: '1', name: 'угловая', shortName: 'угловая', id: '1' },
    {label: 'не угловая', value: '0', name: 'не угловая', shortName: 'не угловая', id: '0' }
  ];
}

function getTrinityYesNoItems () {
  return [
    {label: NOT_IMPORTANT, value: null},
    {label: IS_YES, value: '1'},
    {label: IS_NO, value: '2'}
  ];
}

function getTrinityExistNoItems () {
  return [
    {label: NOT_IMPORTANT, value: null},
    {label: HAS_YES, value: '1'},
    {label: HAS_NO, value: '0'}
  ];
}

function getCase (dictionary) {
  const mapping = {
    [REALTY_TYPES.flat1]: {'singular': {'genitive': 'квартиры'}},
    [REALTY_TYPES.flat2]: {'singular': {'genitive': 'квартиры'}},
    [REALTY_TYPES.flat3]: {'singular': {'genitive': 'квартиры'}},
    [REALTY_TYPES.flat4]: {'singular': {'genitive': 'квартиры'}},
    [REALTY_TYPES.flat5]: {'singular': {'genitive': 'квартиры'}},
    [REALTY_TYPES.flat0]: {'singular': {'genitive': 'квартиры'}},
    [REALTY_TYPES.garageConcrete]: {'singular': {'genitive': 'гаража'}},
    [REALTY_TYPES.garageMetal]: {'singular': {'genitive': 'гаража'}}
  };

  const singular = mapping[dictionary.get('id')] ? fromJS(mapping[dictionary.get('id')].singular) : new Map();

  return new Map({
    singular: dictionary.get('singular').merge(singular)
  });
}

export default function getDictionary (dictionary) {
  function get (key, id) {
    return dictionary.getIn(['entities', 'options', key + '_' + id]);
  }

  function getItems (key, dealType, realtyType) {
    const sectionId = getSection(dealType, realtyType).get('id');

    if (!dictionaryItemsCache[key + sectionId]) {
      const options = dictionary.getIn(['entities', 'units'])
        .filter((item) => item.get('slug') === key)
        .first().get('options')
        .map(item => dictionary.getIn(['entities', 'options', item]))
        .filter(item => {
          if (!item.get('published')) {
            return false;
          }
          if (item.get('sections') === '*') {
            return true;
          }
          return item.get('sections').split(',').indexOf(String(sectionId)) !== -1;
        })
        .map(item => {
          return {
            id: item.get('id'),
            name: item.get('fullName'),
            shortName: item.get('shortName')
          };
        }).toJS();

      dictionaryItemsCache[key + sectionId] = options;
    }

    return dictionaryItemsCache[key + sectionId];
  }

  function getSelectItems (key, dealType, realtyType) {
    const sectionId = getSection(dealType, realtyType).get('id');

    if (!dictionaryItemsCache[key + sectionId]) {
      const options = dictionary.getIn(['entities', 'units'])
        .filter((item) => item.get('slug') === key)
        .first().get('options')
        .map(item => dictionary.getIn(['entities', 'options', item]))
        .filter(item => {
          if (!item.get('published')) {
            return false;
          }
          if (item.get('sections') === '*') {
            return true;
          }
          return item.get('sections').split(',').indexOf(String(sectionId)) !== -1;
        })
        .map(item => {
          return {
            type: 'option',
            value: item.get('id'),
            label: item.get('fullName')
          };
        }).toJS();

      if (defaultOptions[key]) {
        options.unshift(defaultOptions[key]);
      }
      dictionaryItemsCache[key + sectionId] = options;
    }

    return dictionaryItemsCache[key + sectionId];
  }

  function getItemFromItems (items, id) {
    const filtered = items.filter(item => item.value === id);

    if (filtered.length) {
      return new Map({
        shortName: filtered[0].label,
        fullName: filtered[0].label
      });
    }

    return null;
  }

  return {
    getDeadlineItems: getDeadlineItems,
    getObjectTypeItems: function (dealType, realtyType) { return getItems('objectType', dealType, realtyType); },
    getPlanningItems: function (dealType, realtyType) { return getItems('planning', dealType, realtyType); },
    getSanitaryItems: function (dealType, realtyType) { return getItems('sanitary', dealType, realtyType); },
    getRenovationTypeItems: function (dealType, realtyType) { return getItems('renovation', dealType, realtyType); },
    getBuildingTypeItems: function (dealType, realtyType) { return getItems('buildingType', dealType, realtyType); },
    getMaterialTypeItems: function (dealType, realtyType) { return getItems('material', dealType, realtyType); },
    getUsageCategoryItems: function (dealType, realtyType) { return getItems('usageCategory', dealType, realtyType); },
    getHeatingTypeItems: function (dealType, realtyType) { return getItems('heatingType', dealType, realtyType); },
    getFurnitureTypeItems: function (dealType, realtyType) { return getItems('furniture', dealType, realtyType); },
    getApplicationItems: function (dealType, realtyType) { return getItems('application', dealType, realtyType); },
    getWindowTypeItems: function (dealType, realtyType) { return getItems('window', dealType, realtyType); },
    getWindowViewItems: function (dealType, realtyType) { return getItems('windowView', dealType, realtyType); },



    getRentPeriodItems: function (dealType, realtyType) { return getSelectItems('leasePeriod', dealType, realtyType); },
    getGenderItems: function (dealType, realtyType) { return getSelectItems('gender', dealType, realtyType); },
    getPersonNumberItems: function (dealType, realtyType) { return getSelectItems('personNumber', dealType, realtyType); },
    getFloorPositionItems: function (dealType, realtyType) { return getSelectItems('floorPosition', dealType, realtyType); },
    getClaimReasonItems: function (dealType, realtyType) { return getSelectItems('claimReason', dealType, realtyType); },
    getDataSourceItems: function (dealType, realtyType) { return getSelectItems('dataSource', dealType, realtyType); },
    getCornerItems,
    getIntervalInsertedItems: function (dealType, realtyType) { return getSelectItems('interval', dealType, realtyType); },
    getTrinityYesNoItems,
    getTrinityExistNoItems,
    getAuthorItems,
    getDealTypeItems,

    // поиск значения по id
    getCorner: function (id) { return getItemFromItems(getCornerItems(), id); },
    getIntervalInserted: function (id) { return get('interval', id); },
    getTrinityYesNo: function (id) { return getItemFromItems(getTrinityYesNoItems(), id); },
    getTrinityExistNo: function (id) { return getItemFromItems(getTrinityExistNoItems(), id); },
    getAuthor: function (id) { return getItemFromItems(getAuthorItems(), id); },
    getDeadline: function (id) { return getItemFromItems(getDeadlineItems(), id); },
    getFloorPosition: function (id) { return get('floorPosition', id); },
    getMaterial: function (id) { return get('material', id); },
    getSanitary: function (id) { return get('sanitary', id); },
    getObjectType: function (id) { return get('objectType', id); },
    getObjectCase: function (id) { return getCase(get('objectType', id)); },
    getPlanning: function (id) { return get('planning', id); },
    getBalcony: function (id) { return get('balcony', id); },
    getBuildingType: function (id) { return get('buildingType', id); },
    getHeating: function (id) { return get('heatingType', id); },
    getRenovation: function (id) { return get('renovation', id); },
    getDoorType: function (id) { return get('doorType', id); },
    getFloorCovering: function (id) { return get('floorCovering', id); },
    getWindowType: function (id) { return get('window', id); },
    getWindowView: function (id) { return get('windowView', id); },
    getFurniture: function (id) { return get('furniture', id); },
    getParking: function (id) { return get('parking', id); },
    getUsageCategory: function (id) { return get('usageCategory', id); },
    getGender: function (id) { return get('gender', id); },
    getPersonNumber: function (id) { return get('personNumber', id); },
    getRentPeriod: function (id) { return get('leasePeriod', id); },
    getDataSource: function (id) { return get('dataSource', id); },
    getApplication: function (id) { return get('application', id); }
  };
}

export function getAgencies (agencies, constructorName) {
  return agencies.toJS().map(i => ({
    name: `${i.name} (${i.offersCount[constructorName]})`,
    id: i.id,
    shortName: i.name,
  }));
}



// WEBPACK FOOTER //
// ./src/utils/dictionaries.js